export default __webpack_public_path__ + "static/media/Pic14.4f4fd26a.jpg";